import * as React from 'react';
const SvgBackIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={18} fill="none" {...props}>
    <path
      fill="#000"
      d="M11.831 2.833V5.5h5.667c.917 0 1.667.833 1.667 1.75v3.5c0 1-.75 1.75-1.667 1.75H11.83v2.667c0 1.833-2 2.833-3.333 1.666L1.58 10.667c-1-.834-1-2.417 0-3.334l7-6.166C9.831 0 11.831 1 11.831 2.833Z"
    />
  </svg>
);
export default SvgBackIcon;
